export default __webpack_public_path__ + "static/media/Front_Credito_on_light_blue.4b12e471.svg";